import { NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { LayoutService } from 'app/features/layout/services/layout.service';

import { SidemenuComponent } from '../sidemenu/sidemenu.component';
import { UserComponent } from '../widgets/user/user.component';
import { SidebarLogoComponent } from './sidebar-logo/sidebar-logo.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgClass, SidemenuComponent, SidebarLogoComponent, MatTooltip, UserComponent]
})
export class SidebarComponent {
  private readonly layoutService = inject(LayoutService);
  @Input() showToggle = true;
  @Input() showUser = true;
  @Input() toggleChecked = false;

  // Login popup inputs
  @Input() isPopupMinimized: boolean | null = false;
  @Input() isPopupEnabled: boolean | null = false;
  @Input() popupContent = '';

  @Output() toggleCollapsed = new EventEmitter<void>();
  @Output() reopenPopup = new EventEmitter<void>();
  @Output() dismissPopup = new EventEmitter<void>();

  public getCSS(): string {
    const classes: string[] = [`matero-sidebar-main`, `scrollbar-none`];
    if (this.toggleChecked) {
      classes.push(`matero-sidebar-main--close`);
    }
    return classes.join(` `);
  }

  public onReopenPopup(): void {
    this.reopenPopup.emit();
  }

  public onDismissPopup(): void {
    this.dismissPopup.emit();
  }

  public get shouldShowInfoIcon(): boolean {
    return !!this.isPopupEnabled;
  }

  public onTogglePanel(): void {
    this.toggleCollapsed.emit();
    this.layoutService.emitDrawerToggle();
  }
}
